import { createAsyncThunk } from "@reduxjs/toolkit";
import { wpBase, realtyBase } from "../api/base";

////////////////WP REST API////////////////

// FETCH SERVICES
const fetchWpServices = createAsyncThunk(
  "services/fetch",
  async () => {
    try {
      // Fetch sibling categories based on parent category
      const categoriesResponse = await wpBase.get(
        `/wp-json/wp/v2/hp_listing_category?parent=31&per_page=100`
      );

      // Extract category IDs
      const categoryIds = categoriesResponse.data.map((category) => category.id);

      // Fetch posts for all sibling categories
      const postPromises = categoryIds.map((id) =>
        wpBase.get(`/wp-json/wp/v2/hp_listing?hp_listing_category=${id}`)
      );

      // Wait for all post fetches to complete
      const postsByCategory = await Promise.all(postPromises);

      // Combine all posts into a single array
      const allPosts = postsByCategory.flatMap((response) => response.data);

      return allPosts; // Return the combined posts
    } catch (error) {
      console.error("Error fetching posts:", error);
      throw error; // Throw error so it can be handled by createAsyncThunk
    }
  }
);


// FETCH SERVICES DETALS
const fetchWpServicesDetails = createAsyncThunk(
  "servicesDetails/fetch",
  async (carId) => {
    const response = await wpBase.get(`/wp-json/wp/v2/hp_listing/${carId}`);
    return response;
  }
);

// FETCH VENDORS
const fetchWpVendors = createAsyncThunk("vendors/fetch", async (vendorId) => {
  const response = await wpBase.get(`/wp-json/wp/v2/hp_vendor/${vendorId}`);
  return response;
});

////////////////THIRD PARTY API////////////////


export {
  fetchWpServices,
  fetchWpServicesDetails,
  fetchWpVendors,
};
